import React from 'react';
import { MdArrowBack, MdHome, MdCameraAlt, MdAccountBalanceWallet, MdCheckCircle } from 'react-icons/md';

const ReceiptScreen = ({ onNavigate, onBack }) => (
  <div className="screen receipt-screen bh-flow">
    <header className="bh-flow-hero">
      <div className="bh-flow-hero-left">
        <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
          <MdArrowBack />
        </button>
        <h1 className="bh-flow-title">Receipt</h1>
      </div>
    </header>

    <div className="bh-flow-body">
      <div className="bh-form-card" style={{ alignItems: 'center', gap: 'var(--space-md)' }}>
        <div className="bh-success-icon"><MdCheckCircle size={56} /></div>
        <h2 className="bh-success-title">Thank you!</h2>
        <p className="bh-success-subtitle">Your deposit was successful.</p>
        <p className="bh-amount-display" style={{ margin: 0 }}>$547.57</p>
        <p className="bh-success-subtitle" style={{ font: 'var(--bh-caption)' }}>
          Confirmation: AX236HD5-0b32-dgj3-fks830gj3010
        </p>

        <div className="bh-review-rows" style={{ width: '100%' }}>
          <div className="bh-review-row">
            <span className="bh-review-row-label">To Account</span>
            <span className="bh-review-row-value">
              VALUE PLUS<br />
              <span style={{ font: 'var(--bh-caption)', color: 'var(--bh-gray)' }}>3725 083252</span>
            </span>
          </div>
          <div className="bh-review-row">
            <span className="bh-review-row-label">Amount</span>
            <span className="bh-review-row-value" style={{ color: 'var(--td-green)' }}>$547.57</span>
          </div>
          <div className="bh-review-row">
            <span className="bh-review-row-label">Memo</span>
            <span className="bh-review-row-value">Roommate Rent</span>
          </div>
          <div className="bh-review-row">
            <span className="bh-review-row-label">Date</span>
            <span className="bh-review-row-value">July 30th, 2014</span>
          </div>
        </div>
      </div>

      <div className="bh-form-card">
        <div className="bh-action-row">
          <button className="bh-action-card" onClick={() => onNavigate('home')}>
            <div className="bh-action-card-icon"><MdHome /></div>
            <span>Home</span>
          </button>
          <button className="bh-action-card">
            <div className="bh-action-card-icon"><MdCameraAlt /></div>
            <span>Deposit again</span>
          </button>
          <button className="bh-action-card" onClick={() => onNavigate('accounts')}>
            <div className="bh-action-card-icon"><MdAccountBalanceWallet /></div>
            <span>My accounts</span>
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default ReceiptScreen;
